import { SyncLoader } from 'react-spinners';

import { Container } from './styles';

interface IProps {
  position?: string;
}

const Loading = ({
  position = 'absolute'
}: IProps ) => (
  <Container position={position}>
    <SyncLoader color="#fff" />
  </Container>
);

export { Loading };
